<template>
  <v-select
    v-model="Selection"
    :items="data"
    :item-title="finalTitle"
    :item-value="finalColumn"
    :label="boxName"
    density="compact"
    variant="outlined"
    @update:modelValue="changeEventHandler"
    persistent-hint
  >
  </v-select>
</template>
<script>
// import { useStore } from "vuex";
import { ref, onMounted, watchEffect } from "vue";
import { useStore } from "vuex";

export default {
  name: "DropownList",
  props: ["data", "boxName", "boxType"],

  setup(props) {
    const store = useStore();
    const finalColumn = ref("");

    const Selection = ref(null);
    const finalTitle = ref("");
    onMounted(() => {
      // console.log("data", this.data);
      // console.log("data", this.boxName);
      // console.log("data2", this.boxType);

      if (props.boxName === "Campaign Language") {
        finalTitle.value = "text_value";
        finalColumn.value = "id";
        // console.log("data2", props);
      } else if (props.boxName === "From time") {
        finalTitle.value = "value";
      } else if (props.boxName === "Offer Origin") {
        finalTitle.value = "oo_name";
        finalColumn.value = "oo_id";
      } else if (props.boxName === "To time") {
        finalTitle.value = "value";
      } else if (props.boxType === "month") {
        finalTitle.value = "value";
      } else if (props.boxType === "time") {
        finalTitle.value = "value";
      } else if (props.boxName === "Network Name") {
        finalTitle.value = "value";
        finalColumn.value = "id";
      } else if (props.boxName === "Social Media Ad Type") {
        finalTitle.value = "text_value";
        finalColumn.value = "id";
      } else {
        finalTitle.value = "Select One";
      }
      // console.log(22, this.finalTitle);
    });

    watchEffect(() => {
      let dropdown = store.getters["Media/getAdditionalSelectedDataGetters"];
      // let networkSelected =
      //   store.getters["Rawdata/getnetworkNamePayloadGetters"];
      // if (Object.keys(networkSelected).length > 0) {
      //   if (props.boxName === "Network Name") {
      //     Selection.value = networkSelected;
      //   }
      // }
      // let socialSelected =
      //   store.getters["Rawdata/getnetworkNamePayloadGetters"];
      // if (Object.keys(socialSelected).length > 0) {
      //   if (props.boxName === "Social Media Ad Type") {
      //     Selection.value = socialSelected;
      //   }
      // }
      if (Object.keys(dropdown).length > 0) {
        // console.log(dropdown, "dropdown");
        if (props.boxName === "Campaign Language") {
          Selection.value = dropdown["camp"];
        }
        if (props.boxName === "Social Media Ad Type") {
          Selection.value = dropdown["socialmedia_adtype"];
        }
        if (props.boxName === "Network Name") {
          Selection.value = dropdown["external_link"];
        }
        if (props.boxName === "Offer Origin") {
          Selection.value = dropdown["offerOrigin"];
        }
      }
      if (props.data.length === 0) {
        Selection.value = [];
      }
      if (
        Object.keys(store.getters["Rawdata/getsearchDateSelection"]).length !==
        0
      ) {
        let getterData = store.getters["Rawdata/getsearchDateSelection"];
        // console.log(getterData, "getterData");
        if (getterData["approvedDate"]) {
          if (props.boxName === "Start Time") {
            Selection.value = getterData["approvedDate"][1];
            // changeEventHandler();
          }
          if (props.boxName === "End Time") {
            Selection.value = getterData["approvedDate"][3];
            // changeEventHandler();
          }
        }
      }
    });
    function changeEventHandler() {
      // console.log(props.boxName);
      // console.log(Selection.value, props.data, 90);
      // store.dispatch("Rawdata/setTime", Selection.value);
      const searchCry = {
        val: Selection.value,
        column: props.boxName,
        entirs: props.data,
      };
      store.dispatch("Rawdata/setSearchSingleCritertia", searchCry);
      let temp = [];
      if (props.boxName === "Network Name") {
        store.dispatch("Rawdata/setnetworkNamePayloadAction", Selection.value);
      } else if (props.boxName === "Social Media Ad Type") {
        store.dispatch("Rawdata/setsocialPayloadAction", Selection.value);
      } else if (props.boxName === "Start Time") {
        store.dispatch("Rawdata/setbetweenTimePayloadAction", Selection.value);
      } else if (props.boxName === "End Time") {
        store.dispatch("Rawdata/setAndTimePayloadAction", Selection.value);
      } else if (props.boxName === "Offer Origin") {
        // console.log("@.", typeof Selection.value);
        if (typeof Selection.value !== String) {
          const pay = {
            values: Selection.value,
            boxname: props.boxName,
          };
          store.dispatch("Sector/setSiDropDownPayload", pay);
        } else {
          store.dispatch("Sector/setSiDropDownPayload", Selection.value);
        }
      } else if (props.boxName === "Campaign Language") {
        // console.log("@.", Selection.value);
        const pay = {
          values: Selection.value,
          boxname: props.boxName,
        };
        // console.log(pay, "pay");
        store.dispatch("Sector/setDefaultDropdown", pay);
      }
      temp.push(Selection, props.boxName);
      // console.log("temp", temp)
      // this.$emit("sendingData", temp);
    }
    return {
      changeEventHandler,
      finalTitle,
      Selection,
      finalColumn,
    };
  },
};
</script>

<style>
.v-field--center-affix .v-field__append-inner,
.v-field--center-affix .v-field__clearable,
.v-field--center-affix .v-field__prepend-inner {
  margin-right: -5px;
}
</style>
